import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const useCanonicalUrl = () => {
  const location = useLocation()

  useEffect(() => {
    let pathname = location.pathname
    if (pathname !== '/' && !pathname.endsWith('/')) {
      pathname += '/'
    }

    const newUrl = `https://everykits.com${pathname}`

    let canonical = document.querySelector('link[rel="canonical"]')

    if (canonical) {
      if (canonical.getAttribute('href') !== newUrl) {
        canonical.setAttribute('href', newUrl)
      }
    } else {
      canonical = document.createElement('link')
      canonical.setAttribute('rel', 'canonical')
      canonical.setAttribute('href', newUrl)
      document.head.appendChild(canonical)
    }

    const allCanonicals = document.querySelectorAll('link[rel="canonical"]')
    if (allCanonicals.length > 1) {
      allCanonicals.forEach((tag, index) => {
        if (index > 0) tag.remove()
      })
    }
  }, [location.pathname])
}

export default useCanonicalUrl